module.exports = "<div class=\"title\"><h4><a [innerHTML]=\"item.title\"></a></h4></div>\n<div class=\"item-content\">\n  <div [innerHTML]=\"trunc_item_content\"></div>\n  <div>\n    <span class=\"badge\">{{item.pubDate}}</span>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/list-item/list-item.component.html
// module id = ./src/app/list-item/list-item.component.html
// module chunks = main